import {
  BracketIcon
} from "./chunk-SCAGA4V2.mjs";
export {
  BracketIcon
};
